import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';
import moment from 'moment';
import numeral from 'numeral';
import { history } from '../../routers/AppRouter';
import { convertIdToName } from '../../helpers/convertIdToName';

const EntryItem = ({
  vendors,
  id,
  entry_type,
  vendor_id,
  purpose,
  effective_date,
  line_items,
  created_at,
  entry_number,
  isSelected,
  onClick,
  total,
  division_name
}) => (
  <TableRow
    key={id}
    hover
    role="checkbox"
    aria-checked={isSelected}
    tabIndex={-1}
    selected={isSelected}
    style={{ backgroundColor: entry_type === 'cash_in' ? 'rgb(224, 244, 235)' : 'rgba(255, 245, 245)' }}
    >
    <TableCell padding="checkbox">
      <Checkbox checked={isSelected} onClick={(event) => onClick(event, id)}/>
    </TableCell>
    <TableCell>{moment(created_at).format('MM/DD/YY')}</TableCell>
    <TableCell>{moment(effective_date).format('MM/DD/YY')}</TableCell>
    <TableCell>
      <Link to={`/edit/${id}`}>
        <p>{entry_number}</p>
      </Link>
    </TableCell>
    <TableCell>{division_name || entry_type }</TableCell>
    {/* <TableCell>{no_receipt ? <Icon>close</Icon> : <Icon>check</Icon>}</TableCell> */}
    <TableCell>{purpose}</TableCell>
    <TableCell>{convertIdToName(vendor_id, vendors, "vendor_name")}</TableCell>
    {/* <TableCell numeric>{ numeral(
      line_items.reduce((total, { amount }) => {
          return total + parseFloat(amount, 10);
      }, 0)
    ).format('$0,0.00')
    }</TableCell> */}
    <TableCell numeric>{ numeral(total).format('$0,0.00')
    }</TableCell>

    {/* <TableCell numeric>{this.props.momentBalance}</TableCell> */}
  </TableRow>
);

export default EntryItem;

EntryItem.propTypes = {
    id: PropTypes.number.isRequired,
    entry_type: PropTypes.oneOf(['hand_in', 'disbursement', 'cash_in']).isRequired,
    request_from: (props, propName, componentName) => {
      if (props.entry_type === 'disbursement' && (props[propName] === undefined || typeof (props[propName]) !== 'string')) {
        return new Error(
          `Invalid prop ${propName} ${typeof (props[propName])} supplied to
          ${componentName}. expect 'string'.`
        );
      }
    },
    vendor_id: (props, propName, componentName) => {
      if (props.entry_type === 'disbursement' && (props[propName] === undefined || typeof (props[propName]) !== 'number')) {
        return new Error(
          `Invalid prop ${propName} ${typeof (props[propName])} supplied to
          ${componentName}. expect 'number'.`
        );
      }
    },
    purpose: (props, propName, componentName) => {
      if (props.entry_type === 'disbursement' && (props[propName] === undefined || typeof (props[propName]) !== 'string')) {
        return new Error(
          `Invalid prop ${propName} ${typeof (props[propName])} supplied to
          ${componentName}. expect 'string'.`
        );
      }
    },
    // vendor: PropTypes.string.isRequired,
    // purpose: PropTypes.string.isRequired,
    // effective_date: PropTypes.string.isRequired,
    created_at: PropTypes.string.isRequired,
    partial_receipt: PropTypes.bool.isRequired,
    no_receipt: PropTypes.bool.isRequired,
    line_items: PropTypes.arrayOf(PropTypes.shape({
      description: PropTypes.string.isRequired,
      amount: PropTypes.string.isRequired,
      expense_account_id: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired
    })).isRequired
  };



// WEBPACK FOOTER //
// ./src/components/entries/EntryItem.js